import {animate, inView} from 'motion';

const body = document.body;

if (body.classList.contains('home')) {
	// Home Hero Section
	inView('section.home-hero', ({target}) => {
		const contentElements = target.querySelectorAll('.ui-container > *');

		for (let i = 0; i < contentElements.length; i++) {
			const animationDelay = 0.15 + i * 0.1;
			animate(
				contentElements[i],
				{opacity: 1, transform: 'translate3d(0,0,0)'},
				{delay: animationDelay, duration: 0.3, easing: 'ease-out'},
			);
		}

		animate(
			target.querySelector('#home-hero-layer-1'),
			{opacity: 1, transform: 'translate3d(0,0,0)'},
			{delay: 0.25, duration: 0.6, easing: 'ease-out'},
		);
	});

	// Elements in basic Section
	inView('section:not(.home-hero)', ({target}) => {
		const contentElements = target.querySelectorAll(
			'p,.wp-block-heading,.wp-block-image,.wp-block-video,.wp-block-button__link,.booking-types',
		);

		for (let i = 0; i < contentElements.length; i++) {
			const animationDelay = 0.5 + i * 0.1;
			animate(
				contentElements[i],
				{opacity: 1, transform: 'translate3d(0,0,0)'},
				{delay: animationDelay, duration: 0.3, easing: 'ease-out'},
			);
		}
	});
}
